import { Box, DialogActions, FormControl, TextField } from '@mui/material';
import styled from 'styled-components';
import { colors } from 'utils/colors';

export const TextInputP = styled(TextField)`
  input {
    margin-top: 8px;
    border: 1px solid ${colors.verde05} !important;
    border-radius: 5px !important;
    padding: 5px 30px 5px 8px !important;
    @media (max-width: 522px) {
      width: 100% !important;
    }
  }

  @media (max-width: 522px) {
    width: 100% !important;
  }
`;

export const ButtonOrcamento = styled.div`
  color: #f6f6f6;
  background-color: ${colors.verde05};
  border: 1px solid ${colors.verde05};
  width: 250px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
  transition: ease-in-out 250ms;

  &:hover {
    background-color: ${colors.branco};
    color: ${colors.verde05};
  }
`;

export const FiltroWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  @media (max-width: 522px) {
    gap: 10px;
    justify-content: center;
  }
`;

export const TFormControl = styled(FormControl)`
  margin-left: 50px !important;
  span {
    font-size: 13px !important;
  }
`;

export const TDialogActions = styled(DialogActions)`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
`;
